import GiveDecisionView from 'components/CommiteeDecision/GiveDecisionView';

const GiveDecision = () => {
  return <GiveDecisionView />;
};

export default GiveDecision;
